
function checkSubmit() {
	return true;
}

IF.init = function() {
	//this.loginBoxAnimation();
};

